import React from 'react';
import s from './styles.module.css'
import Wrapper from '../../components/wrapper';
import HeaderTitle from '../../components/header_title';

const PrivacyPolicy = () => {
  return (
    <div className={s.main}>
      <Wrapper>
        <HeaderTitle/>
        <h1>Política de Privacidad</h1>

        <h2>1. Introducción</h2>

        <p>
          Bienvenido a HiMyLoan ("nosotros", "nuestro" o "el sitio web").
        </p>

        <p>
          Esta Política de Privacidad explica cómo recopilamos, utilizamos y protegemos la información personal de los usuarios que visitan https://himyloan.com/ (en adelante, el "Sitio Web").
        </p>

        <p>
          Nos comprometemos a proteger la privacidad de nuestros usuarios y a tratar sus datos personales de acuerdo con la normativa aplicable, incluyendo el Reglamento General de Protección de Datos (RGPD) de la Unión Europea.
        </p>

        <h2>2. Responsable del tratamiento</h2>

        <p>
          El responsable del tratamiento de los datos recopilados a través de este Sitio Web es una persona de HiMyLoan.
        </p>

        <h2>3. Información que recopilamos</h2>

        <p>
          Podemos recopilar diferentes tipos de información cuando utiliza nuestro Sitio Web.
        </p>

        <h3>Información proporcionada voluntariamente</h3>

        <p>
          Cuando un usuario se pone en contacto con nosotros, podemos recopilar:
        </p>

        <ul>
          <li>Nombre;</li>
          <li>Dirección de correo electrónico;</li>
          <li>Cualquier información incluida en el mensaje enviado.</li>
        </ul>

        <h3>Información recopilada automáticamente</h3>

        <p>
          Cuando visita nuestro Sitio Web, podemos recopilar automáticamente información técnica, incluyendo:
        </p>

        <ul>
          <li>Dirección IP;</li>
          <li>Tipo y versión del navegador;</li>
          <li>Información del dispositivo;</li>
          <li>Sistema operativo;</li>
          <li>Páginas visitadas;</li>
          <li>Tiempo de navegación;</li>
          <li>Fuente de referencia desde la que accedió al sitio.</li>
        </ul>

        <h2>4. Finalidad del tratamiento de datos</h2>

        <p>
          Utilizamos la información recopilada para:
        </p>

        <ul>
          <li>Mantener y mejorar el funcionamiento del Sitio Web;</li>
          <li>Mejorar la experiencia del usuario;</li>
          <li>Analizar el tráfico y rendimiento del sitio;</li>
          <li>Responder consultas enviadas por los usuarios;</li>
          <li>Prevenir usos fraudulentos o indebidos;</li>
          <li>Cumplir obligaciones legales.</li>
        </ul>

        <h2>5. Google Analytics</h2>

        <p>
          Utilizamos Google Analytics para analizar cómo los usuarios interactúan con nuestro Sitio Web y mejorar nuestro contenido.
        </p>

        <p>
          Google Analytics puede recopilar información como:
        </p>

        <ul>
          <li>Páginas visitadas;</li>
          <li>Duración de la visita;</li>
          <li>Tipo de dispositivo utilizado;</li>
          <li>Navegador utilizado;</li>
          <li>Ubicación aproximada del usuario.</li>
        </ul>

        <p>
          La información recopilada por Google Analytics se procesa de acuerdo con la política de privacidad de Google.
        </p>

        <h2>6. Cookies</h2>

        <p>
          Nuestro Sitio Web utiliza cookies y tecnologías similares para mejorar la navegación, analizar el tráfico y proporcionar una mejor experiencia al usuario.
        </p>

        <p>
          Los usuarios pueden configurar o rechazar el uso de cookies mediante la configuración de su navegador.
        </p>

        <p>
          Para obtener más información, consulte nuestra Política de Cookies.
        </p>

        <h2>7. Servicios y enlaces de terceros</h2>

        <p>
          Nuestro Sitio Web puede contener enlaces hacia sitios web de terceros, incluyendo socios comerciales y proveedores de servicios financieros.
        </p>

        <p>
          No somos responsables del contenido, las prácticas de privacidad o las políticas de sitios web externos.
        </p>

        <h2>8. Enlaces de afiliados</h2>

        <p>
          El sitio participa en programas de afiliación.
        </p>

        <p>
          Algunos enlaces del Sitio Web pueden ser enlaces de afiliado. Esto significa que podemos recibir una comisión si un usuario realiza una acción a través de dichos enlaces, sin ningún coste adicional para el usuario.
        </p>

        <p>
          Las relaciones de afiliación ayudan a mantener y mejorar nuestro Sitio Web.
        </p>

        <h2>9. Derechos del usuario según el RGPD</h2>

        <p>
          Los usuarios tienen derecho a:
        </p>

        <ul>
          <li>Solicitar acceso a sus datos personales;</li>
          <li>Solicitar la corrección de datos incorrectos;</li>
          <li>Solicitar la eliminación de sus datos;</li>
          <li>Oponerse o limitar determinados tratamientos;</li>
          <li>Solicitar la portabilidad de sus datos cuando corresponda.</li>
        </ul>

        <p>
          También tiene derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (AEPD).
        </p>

        <h2>10. Conservación de datos</h2>

        <p>
          Conservaremos los datos personales únicamente durante el tiempo necesario para cumplir las finalidades descritas en esta política o cuando exista una obligación legal de conservarlos.
        </p>

        <h2>11. Seguridad de la información</h2>

        <p>
          Aplicamos medidas razonables para proteger la información recopilada.
        </p>

        <p>
          Sin embargo, ningún método de transmisión o almacenamiento electrónico es completamente seguro y no podemos garantizar una seguridad absoluta.
        </p>

        <h2>12. Privacidad de menores</h2>

        <p>
          Nuestro Sitio Web no está dirigido a menores de 16 años.
        </p>

        <p>
          No recopilamos conscientemente información personal de menores.
        </p>

        <h2>13. Cambios en esta Política de Privacidad</h2>

        <p>
          Podemos actualizar esta Política de Privacidad cuando sea necesario debido a cambios legales, técnicos o relacionados con nuestros servicios.
        </p>
      </Wrapper>
    </div>
  );
};

export default PrivacyPolicy;
